import { useQuery } from '@tanstack/react-query'
import { swimApi } from '@swim/api-client'
import { useSession } from '@/hooks/use-session'
import { QUERY_KEYS } from '@/lib/queryKeys'

export interface MyStream {
  id: string
  name: string
  slug: string
  avatarUrl?: string | null
  status: 'LIVE' | 'INACTIVE'
}

export interface MyWorkspace {
  id: string
  businessName: string
  avatarUrl?: string | null
  streams: MyStream[]
}

export interface MyStreamsData {
  workspaces: MyWorkspace[]
}

/**
 * Returns the current user's merchant record and their streams.
 * Only fetches when the user is authenticated and has MERCHANT role.
 */
export function useMyStreams() {
  const { user, isMerchant } = useSession()

  return useQuery({
    queryKey: QUERY_KEYS.account.myStreams(),
    queryFn: async (): Promise<MyStreamsData> => {
      const result = await swimApi.get<MyStreamsData>('/account/my-streams')
      if (!result.success) throw new Error(result.error)
      return result.data
    },
    enabled: !!user && isMerchant,
    staleTime: 0,  // refetch on window focus so new workspaces/streams appear without manual refresh
  })
}
